//////////////////////////////////////////////
//! WebCamView 
//////////////////////////////////////////////

ImageEditView = function( dispatcher ) {

//--------------------------------------------
//! Static Vars
//--------------------------------------------

	this.IMAGE_WIDTH = 390;
	this.CANVAS_WIDTH = 690;
	this.PORTRAIT_WIDTH = 540;
	this.PORTRAIT_HEIGHT = 690;
	this.ORANGE_COLOR = 0xff5408;
	this.CANVAS_BK_COLOR = 0xffffff;

	this.NUMBER_BOX_WIDTH = 106;
	this.NUMBER_BOX_HEIGHT = 106;

//--------------------------------------------
//! Vars
//--------------------------------------------

	this.dispatcher = dispatcher;
	
	//render vars
	this.fps = 24;
	this.now = 0;
	this.then = Date.now();
	this.interval = 1000 / 24;
	this.delta = 0;

//--------------------------------------------/

	this.update.bindX( this );
	this.onPhotoReady.bindX( this );
	this.init();

};

ImageEditView.prototype = {

	constructor : ImageEditView,

	/*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function() {

		this.initGL();
		
		this.bindEvents();
		this.createImageContainer();
		this.initSliders();
		this.hermite = new Hermite_class();

	},

	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/

	initGL : function() {
		this.titleLoader = new PIXI.loaders.Loader();
		this.titleLoader.add("title", "media/img/new_logo.png");
		this.titleLoader.load();
		this.pixiLoader = new PIXI.loaders.Loader();
		this.pixiLoader.on( "complete" ,  this.onPhotoReady.bindX( this ) );
		this.stage = new PIXI.Container();
		this.renderer = new PIXI.autoDetectRenderer( this.CANVAS_WIDTH , this.PORTRAIT_HEIGHT, { preserveDrawingBuffer : false ,  antialias : true, interactive : true, resolution :window.devicePixelRatio || 1 , transparent : true } );
		
		if(Detectizr.device.type === "desktop" ){
			this.resizeDesktop();
		}else{
			this.resizeMobile();
		}
		
		$(dom.canvasHolder).append( this.renderer.view );
	},
	
	resizeDesktop : function(){
		this.renderer.view.style.width = $(dom.landing.container).height() + "px";
		this.renderer.view.style.height = $(dom.landing.container).height() + "px";
	},
	
	resizeMobile : function(){

		var topHeight = $(dom.header).height();
		
		var viewportHeight = $(dom.viewport).height() ;
		var footerPaddingDifViewport = parseInt( $(dom.viewport).css("padding-bottom") ) - parseInt($(dom.footer).css("padding-bottom"))

		var footerHeight = 0//$( dom.footer ).height() - parseInt($(dom.footer).css("padding-bottom")) - footerPaddingDifViewport;
		footerHeight = 36; // hardcoded
		var bottomHeight = footerHeight + $( dom.navigation.next).height() +20;

		var canvasHeight = viewportHeight - ( bottomHeight + topHeight) - 20;
		
		var space = ( viewportHeight - canvasHeight ) / 2;
		var dif = topHeight - bottomHeight + 10;

		//this.renderer.view.style.marginTop =  (dif) + "px";
		var canvasHeight = viewportHeight - (topHeight + bottomHeight + 20); 

		this.renderer.view.style.width = canvasHeight + "px";
		this.renderer.view.style.height = canvasHeight + "px";
	},

	initSliders : function(){

		this.brightness_slider = new SliderView( GLOBALS.brightness_slider_url , this.PORTRAIT_HEIGHT, this.dispatcher , EVENTS.BRIGHTNESS_SLIDER_UPDATE);
		this.brightness_slider.max = 1;
		this.brightness_slider.min = 2;

		this.contrast_slider = new SliderView( GLOBALS.contrast_slider_url , this.PORTRAIT_HEIGHT, this.dispatcher , EVENTS.CONTRAST_SLIDER_UPDATE);
		this.contrast_slider.max = 0;
		this.contrast_slider.min = 1;

		this.scale_slider = new SliderView( GLOBALS.scale_slider_url , this.PORTRAIT_HEIGHT, this.dispatcher , EVENTS.RESIZE_SLIDER_UPDATE );
		this.scale_slider.max = 0;
		this.scale_slider.min = 2;


		this.stage.addChild( this.brightness_slider.container );
		this.stage.addChild( this.contrast_slider.container );
		this.stage.addChild( this.scale_slider.container );

		this.brightness_slider.container.position.x = 390 + 11 ;
		this.scale_slider.container.position.x = 390 + 11 ;
		this.contrast_slider.container.position.x = 390 + 22 + 130;
	},

	bindEvents : function() {

		this.dispatcher.addEventListener( EVENTS.TOGGLERENDER ,this.onToggleRender.bindX( this ) );
		this.dispatcher.addEventListener( EVENTS.RESIZE, this.onStageResize.bindX (this ) );
		this.dispatcher.addEventListener( EVENTS.SHOWEDITIMAGE, this.onResetCanvas.bindX (this ) );
		this.dispatcher.addEventListener( EVENTS.SHOW_FILTERS, this.onShowFilters.bindX (this ) );
		this.dispatcher.addEventListener( EVENTS.GENERATE_IMAGE, this.onShowFinalImage.bindX (this ) );


		this.dispatcher.addEventListener( EVENTS.RESIZE_SLIDER_UPDATE, this.onScaleSliderUpdate.bindX (this ) );
		this.dispatcher.addEventListener( EVENTS.CONTRAST_SLIDER_UPDATE, this.onContrastSliderUpdate.bindX (this ) );
		this.dispatcher.addEventListener( EVENTS.BRIGHTNESS_SLIDER_UPDATE, this.onBrightnessSliderUpdate.bindX (this ) );

	},

	initFilters : function() {
		this.filter = new PIXI.filters.ColorMatrixFilter();
		this.filterC = new PIXI.filters.ColorMatrixFilter();
		this.filter.matrix = this.getMatrix();
		this.filterC.matrix = this.getMatrix();
		this.filterC.contrast( 0 ,false);
		this.filter.brightness( 1 , false );
		this.photoSprite.filters = [ this.filterC , this.filter];
		//this.filter.resolution = window.devicePixelRatio;
//
	////	this.filterC.resolution = window.devicePixelRatio;
//
	//	
	//	
	//	this.filter.matrix = this.getMatrix();
	//	this.filterC.matrix = this.getMatrix();
//
	//	this.filterC.contrast( 0 ,false);
//
	//	this.filter.brightness( 1 , false );
//
	//	//this.photoSprite.filters = [ this.filterC , this.filter];
	//	
	},

	getMatrix : function(){
	
		var matrix = [
			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1
		];
		return matrix;
	
	},
	
	createImageContainer : function(){

		this.imageContainer = new PIXI.Container();
		var mask = new PIXI.Graphics();
		mask.beginFill();
		mask.drawRect(0 ,0 , 390 , this.PORTRAIT_HEIGHT ); // drawRoundedRect(x, y, width, height, radius)
		mask.endFill();
		this.imageContainer.addChild( mask );
		this.imageContainer.mask = mask;
		this.stage.addChild( this.imageContainer );
		this.imageContainer.position.x = 0;

		this.instructionBox = new PIXI.Container();
		//this.instructionBox.anchor.y = 0.5;
		var box = new PIXI.Graphics();
		box.beginFill(0xffffff);
		box.drawRect(0 ,0 , 390 , 130 ); // drawRoundedRect(x, y, width, height, radius)
		box.endFill();
		this.instructionBox.addChild(box);
		this.stage.addChild(this.instructionBox);
		this.instructionBox.position.y = this.PORTRAIT_HEIGHT / 2 -65; 
		this.tileTexture = PIXI.Texture.fromImage('media/img/tile.jpg');

		this.instruction1  = new PIXI.Text( "Drag your photo into position\nand use the slider to scale it." , { font : '25px Nimbus-Bol', fill: this.ORANGE_COLOR, align: 'center' });
		this.instruction1.position.set( 20, 35 );
		this.instruction1.resolution = window.devicePixelRatio || 1 ;
		this.instructionBox.addChild(this.instruction1);

		this.instruction2  = new PIXI.Text( "Adjust the brightness\nand contrast using the sliders." , { font : '25px Nimbus-Bol', fill: this.ORANGE_COLOR, align: 'center' });
		this.instruction2.position.set( 20, 35 );
		this.instruction2.resolution = window.devicePixelRatio || 1 ;
		this.instructionBox.addChild(this.instruction2);
		this.instruction2.alpha = 0;

		this.instructionBox.alpha = 0;
	},

	update : function() {
		this.now = Date.now();
		this.delta = this.now - this.then;

		if ( this.delta > this.interval ) {

			this.renderer.render( this.stage );
			this.then = this.now - ( this.delta % this.interval );
		}

		this.animRequest = requestAnimationFrame( this.update.bindX( this ) );
	},

	addTitle : function(){

		// create a new Sprite using the texture
	
		this.titleBK = new PIXI.TilingSprite(this.tileTexture, 150, this.PORTRAIT_HEIGHT)
	
		this.titleBK.position.set( this.PORTRAIT_WIDTH - 150, 0 );
		this.titleBK.position.x = this.IMAGE_WIDTH;
		this.stage.addChild( this.titleBK );

		this.title = new PIXI.Text( GLOBALS.name , { font : '120px Nimbus-Bol', fill: 'white', align: 'left' });
		this.title.position.set( this.PORTRAIT_WIDTH - 75, this.PORTRAIT_HEIGHT - 20 );
		this.title.anchor.x = 0;
		this.title.anchor.y = 0.5;

		this.title.resolution = 2;
		this.title.rotation = - 90 * Math.PI / 180;
		this.stage.addChild( this.title );
		this.title.position.x = this.IMAGE_WIDTH + 75;
		this.titleBK.position.x = this.IMAGE_WIDTH ;

	},
	
	addNumberBox : function(){
		var numberPadding = 12;

		//BACKGROUND BOX
		this.boxBK = new PIXI.TilingSprite( this.tileTexture, this.NUMBER_BOX_WIDTH, this.NUMBER_BOX_HEIGHT );
		this.boxBK.position.set( 0, this.PORTRAIT_HEIGHT - this.NUMBER_BOX_HEIGHT );
		this.stage.addChild( this.boxBK );

		this.numberContainer = new PIXI.Container();

		//HASHTAG
		this.hashtag = new PIXI.Text( "#" , { font : '50px Nimbus-Bol', fill: 'white', align: 'left' });
		//this.hashtag.position.set( this.NUMBER_BOX_WIDTH / 2 , this.boxBK.position.y );
		this.hashtag.anchor.x = 0.5;
		this.hashtag.anchor.y = 0.5;
		this.hashtag.resolution = 2;
		this.numberContainer.addChild( this.hashtag );

		//NUMBER
		var randomNumber = Math.floor ( Math.random() * 5 ) + 1;
		this.number = new PIXI.Text( randomNumber , { font : '100px Nimbus-Bol', fill: 'white', align: 'left' });
	//	this.number.position.set( this.NUMBER_BOX_WIDTH / 2 + this.hashtag.width / 2 , this.boxBK.position.y );
		this.number.anchor.x = 0.5;
		this.number.anchor.y = 0.5;
		this.number.resolution = 2;
		this.numberContainer.addChild( this.number );
		this.stage.addChild( this.numberContainer );

		this.hashtag.position.x = - this.number.width / 2 - this.hashtag.width / 2;
		this.hashtag.position.y = - this.number.height / 2 + this.hashtag.height / 2 + numberPadding;
		this.numberContainer.position.x = this.NUMBER_BOX_WIDTH / 2 + this.hashtag.width / 2;
		this.numberContainer.position.y = this.PORTRAIT_HEIGHT - this.NUMBER_BOX_HEIGHT / 2;
	},

	addMovieTitleBox : function() {
		//movie title Box
		this.movieTitleBK = new PIXI.Graphics();
		this.movieTitleBK.lineStyle( 1 , this.ORANGE_COLOR );
		this.movieTitleBK.drawRect( 0, 0, 284, 77 );
		this.movieTitleBK.endFill();
		this.movieTitleBK.position.set( 106, this.PORTRAIT_HEIGHT - this.NUMBER_BOX_HEIGHT + 1 );
		this.stage.addChild( this.movieTitleBK );

		//movie release date Box
		this.movieDateBK = new PIXI.Graphics();
		this.movieDateBK.lineStyle( 1 , this.ORANGE_COLOR );
		this.movieDateBK.drawRect( 0, 0, 140, 31 );
		this.movieDateBK.endFill();
		this.movieDateBK.position.set( 106, this.PORTRAIT_HEIGHT - 31 + 3 );
		this.stage.addChild( this.movieDateBK );

		var movieTitlePadding = 10;
		this.movieTitle = new PIXI.Sprite( this.titleLoader.resources.title.texture );
		this.movieTitle.resolution = 2;
		this.movieTitle.scale.x = 0.5;
		this.movieTitle.scale.y = 0.5;
		this.stage.addChild( this.movieTitle );
		this.movieTitle.position.set(this.NUMBER_BOX_WIDTH + movieTitlePadding , this.PORTRAIT_HEIGHT - this.NUMBER_BOX_HEIGHT + movieTitlePadding)

		//this.movieTitle = new PIXI.Text( "T2 Trainspotting" , { font : '34px Nimbus-Bol', fill: 'white', align: 'left' });
		//this.stage.addChild( this.movieTitle );

		this.movieReleaseDate = new PIXI.Text( localisation.release_date.released , { font : '14px Nimbus-Bol', fill: this.ORANGE_COLOR, align: 'left' });
		this.stage.addChild( this.movieReleaseDate );
		this.movieReleaseDate.position.set(this.NUMBER_BOX_WIDTH + movieTitlePadding , this.PORTRAIT_HEIGHT - 23 )

	},

	addFrame : function(){
		//movie release date Box
		this.frame = new PIXI.Graphics();
		this.frame.lineStyle( 2 , 0xffffff ,1);
		this.frame.drawRect( 0, 0, this.PORTRAIT_WIDTH - 1, this.PORTRAIT_HEIGHT -1 );
		this.frame.endFill();
		this.frame.position.set( 0.5 , 0.5 );
		this.stage.addChild( this.frame );
	},

	loadPhoto : function(){

		if( this.photoSprite ) this.removePhoto();
		this.pixiLoader.add( 'b64', app.uploadView.current_Image );
		this.pixiLoader.load();

		//SET SLIDER POSITION TO 0 JUST IN CASE
		this.scale_slider.reset( );
		this.brightness_slider.reset( );
		this.contrast_slider.reset( );

	},
	
	removePhoto : function(){

		this.imageContainer.removeChild( this.photoSprite );
		PIXI.TextureCache.b64.destroy();
		this.pixiLoader.reset();
		this.photoSprite.filters = null;
		this.photoSprite.filters = null;
		this.photoSprite = null;
	
	},

	createPhoto : function(){
		
		this.photoSprite = new PIXI.Sprite( this.pixiLoader.resources.b64.texture );
		
		this.photoSprite.anchor.x =  0.5;
		this.photoSprite.anchor.y =  0.5;
		TweenMax.delayedCall( 0.5, this.fitImageToPortrait.bindX( this ) );
		

		this.photoSprite.position.set( ( ( this.PORTRAIT_WIDTH - 150 ) / 2 ) , this.PORTRAIT_HEIGHT / 2 );
		

		//INTERACTIVE

		this.photoSprite.interactive = true;
		this.photoSprite.buttonMode = true;
		
		// events for drag start

		this.photoSprite.on( 'mousedown' , this.onDragStart.bindX( this ) );
		this.photoSprite.on( 'touchstart' , this.onDragStart.bindX( this ) );

		// events for drag end

		this.photoSprite.on( 'mouseup', this.onDragEnd.bindX( this ) );
		this.photoSprite.on( 'mouseupoutside', this.onDragEnd.bindX( this ) );
		this.photoSprite.on( 'touchend', this.onDragEnd.bindX( this ) );
		this.photoSprite.on( 'touchendoutside', this.onDragEnd.bindX( this ) );

		// events for drag move

		this.photoSprite.on( 'mousemove', this.onDragMove.bindX( this ) );
		this.photoSprite.on( 'touchmove', this.onDragMove.bindX( this ) );

	},
	
	fitImageToPortrait : function( ){

		var ratio = this.photoSprite.height / this.photoSprite.width;
		var scale = ( this.PORTRAIT_HEIGHT / this.photoSprite.height ) ;
		this.photoSprite.scale.y = this.photoSprite.scale.x = scale + 0.05;

		this.getScaleRanges();
		this.imageContainer.addChild( this.photoSprite );

	},
	
	getScaleRanges : function( ){
		
		this.scale_slider.max = this.photoSprite.scale.x;
		this.scale_slider.min = this.photoSprite.scale.x * 2;
		
		//this.dispatcher.dispatch( EVENTS.SCALE_RANGE_CHANGE, this.ranges );
	},

	checkDragLimitsX : function( pos ){

		if( ( pos > ( 390 - ( this.photoSprite.width / 2 ) ) ) 
			&& ( pos < ( this.photoSprite.width / 2 ) )){
			return true;

		}else {
			
			//this.correctDragPositionX();
			return false;

		}

	},

	checkDragLimitsY : function( pos ){
		if( ( pos > ( this.PORTRAIT_HEIGHT  -  this.photoSprite.height / 2 ) ) 
			&& ( pos < ( this.photoSprite.height / 2 ) ) ){
			return true;
		}else{
			//this.correctDragPositionY();
			return false;
		}
	},

	correctDragPositionX : function( ){

		var posX =  this.photoSprite.position.x;
		
		var limitX = ( 390 - ( this.photoSprite.width / 2 ) );

		if ( this.photoSprite.position.x <= limitX ) {
			posX =  limitX ; 
		}
		
		if( this.photoSprite.position.x >=  ( this.photoSprite.width / 2 ) ){
			posX =   ( this.photoSprite.width / 2 ) ;
		} 
//
		
		TweenMax.to( this.photoSprite.position, 0, { x : posX,  ease : Elastic.easeIn } );

	},

	correctDragPositionY : function( ){

		var posY = this.photoSprite.position.y;
		var limitY = ( this.PORTRAIT_HEIGHT  -  this.photoSprite.height / 2 );

		if ( this.photoSprite.position.y <= limitY ) {
			posY = 1 + limitY;
		}

		if( this.photoSprite.position.y >=  ( this.photoSprite.height / 2 ) ){
			posY =  -1 + ( this.photoSprite.height / 2 );
		}	


		TweenMax.to( this.photoSprite.position, 0, { y : posY,  ease : Elastic.easeIn } );
	
	},

	destroyFrameAssets : function(){

		if(! this.movieTitleBK ) return;
		

		var items = [ this.movieTitleBK , this.movieDateBK , this.movieReleaseDate,
		this.titleBK , this.title , this.boxBK,
		this.numberContainer, this.frame , this.movieTitle];

		var l = items.length;
		for( var i = 0; i < l ; i++){
			this.stage.removeChild( items[ i ] );
			items[ i ].destroy();
			items[ i ] = null;
		}

		items = null;
		
		this.movieTitleBK = this.movieDateBK = this.movieReleaseDate = 
		this.titleBK = this.title = this.boxBK = 
		this.numberContainer = this.frame = this.movieTitle = null;


	
	},
	
	showInstructions : function (inst){
		this.hideInstructions();
		inst.alpha = 1;
		TweenMax.fromTo(this.instructionBox,0.2,{alpha:0},{alpha:1});
	},

	hideInstructions : function(){
		this.instruction2.alpha = 0;
		this.instruction1.alpha = 0;
		this.instructionBox.alpha = 0;
	},

	/*---------------------------------------------------
		EVENT HANDLERS 
	--------------------------------------------------*/

	onPhotoReady : function(){
		this.createPhoto();
		this.initFilters();
		this.showInstructions( this.instruction1 );
		TweenMax.fromTo(this.instructionBox,0.2,{alpha:0},{alpha:1});
	},

	onResetCanvas : function( e , data ){
		if(!data) this.loadPhoto();
		else  this.showInstructions( this.instruction1 );
		this.addImageDrag();
		this.scale_slider.toggleView( true );
		this.brightness_slider.toggleView( false );
		this.contrast_slider.toggleView( false );

	},

	onToggleRender : function( e , on ){
		
		if( on ) this.update();
		else{
			if( this.animRequest ) window.cancelAnimationFrame( this.animRequest );
		}

	},

	onStageResize : function( e ){
		if(Detectizr.device.type != "desktop"){
			this.resizeMobile();

		}
	},

	onShowFilters : function( e , back ){
		this.renderer.resize(this.CANVAS_WIDTH  , this.CANVAS_WIDTH );
		this.renderer.render( this.stage );
		this.removeImageDrag();
		if( back ) this.destroyFrameAssets();
		this.showInstructions( this.instruction2 );
		this.scale_slider.toggleView( false );
		this.brightness_slider.toggleView( true );
		this.contrast_slider.toggleView( true );
	},
	
	addImageDrag : function(){

		if( this.photoSprite ) this.photoSprite.interactive = true;
	
	},

	removeImageDrag : function(){

		this.photoSprite.interactive = false;
	
	},
	
	renderPoster : function(){
		this.hideInstructions();
		var ratio = window.devicePixelRatio || 1;
		this.renderer.resize(540 , 690 )
		

		this.renderer.render( this.stage );
		var sourceCanvas = this.renderer.extract.canvas();
		var sourceContext = sourceCanvas.getContext( '2d' );

		this.dataPoster = sourceContext.canvas.toDataURL( 'image/jpg' , 1 );
		
		

		$(".poster").attr("src", this.dataPoster);
		if( (Detectizr.browser.name === "ie") || (Detectizr.browser.name==="edge"))return;

		$(".poster2").attr("src", this.dataPoster);
		GLOBALS.twitterImg = this.dataPoster
		$(dom.sharePage.downloadPoster).attr("href", this.dataPoster);
		if(ratio > 1 ) this.twitterImgFix();
		
	},
	
	twitterImgFix : function(){
		this.twTag = Utils.createImage( this.dataPoster, function(){
			this.twTag.onload = null;
			this.hermite.quickResize(this.twTag, 540, 690, false , function(){
				console.log("image ready")
				GLOBALS.twitterImg = this.twTag.src;
			}.bindX(this))
		}.bindX(this))
	},

	/****************************************************
		DRAGING HANDLERS 
	//***************************************************/

	onDragStart : function ( e ) {
		this.instructionBox.alpha = 0;
		this.data = e.data;
		var newPosition = this.data.getLocalPosition( this.imageContainer );
		this.distanceX =  newPosition.x ; 
		this.distanceY = newPosition.y ;
		this.startX = this.photoSprite.position.x; 
		this.startY = this.photoSprite.position.y;
		this.dragging = true;

	},

	onDragEnd : function() {

		this.dragging = false;
		this.data = null;

	},

	onDragMove : function() {
		
		if ( this.dragging ) {
			var newPosition = this.data.getLocalPosition( this.imageContainer );
			var xPos = this.startX + ( newPosition.x - this.distanceX );
			var yPos = this.startY + ( newPosition.y - this.distanceY );
			if( this.checkDragLimitsX( xPos ) ) this.photoSprite.position.x = xPos;
			if( this.checkDragLimitsY( yPos ) ) this.photoSprite.position.y = yPos;
		}

	},

	/****************************************************
		SLIDER HANDLERS 
	/****************************************************/

	onScaleSliderUpdate : function ( e , data ){
		this.instructionBox.alpha = 0;
		this.correctDragPositionX();
		this.correctDragPositionY();
		this.photoSprite.scale.x = data;
		this.photoSprite.scale.y = data;
	
	},

	onContrastSliderUpdate : function ( e , data ){
		console.log("update")
		this.instructionBox.alpha = 0;
		this.filterC.contrast( 0 , false );
		this.filterC.contrast( parseFloat( data ) , true );
	
	},

	onBrightnessSliderUpdate : function ( e , data ){
		console.log("update")
		this.instructionBox.alpha = 0;
		this.filter.brightness( parseFloat( data ) , false );

	},

	/*---------------------------------------------------*/

	onShowFinalImage : function( e , data ){
		this.removeImageDrag()
		this.destroyFrameAssets();

		this.imageContainer.position.x = 0;

		this.addMovieTitleBox();
		this.addTitle();
		this.addNumberBox();
		this.addFrame();

		this.scale_slider.toggleView( false );
		this.brightness_slider.toggleView( false );
		this.contrast_slider.toggleView( false );
		this.renderPoster();
	}

};
